import * as React from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Alert } from '@mui/material';
import ArticlesModule from '../Components/ArticlesModule';
import { articlesStepSchema } from './validation';
import useStepForm from '../../components/form/MultiStepForm/useStepForm';
import { MultiStepContextProps } from '../../components/form/MultiStepForm/types';

type StepArticle = { invoicingCategory?: string | null };

/** Form second step : Articles | Content of package */
const ArticleStep: React.FunctionComponent<MultiStepContextProps> = function (props) {
    // Props
    const { multiStepForm, isCreate } = props;
    const { setCurrentFormContext, formValues, updateFormValues } = multiStepForm;

    // Form configuration
    const formContext = useForm({
        mode: 'onBlur',
        defaultValues: { ...formValues },
        resolver: zodResolver(articlesStepSchema),
    });

    const { isStepValidating } = useStepForm(formContext, multiStepForm);

    React.useEffect(() => {
        setCurrentFormContext(formContext);
    }, [formContext, setCurrentFormContext]);

    // Remonte en continu les articles vers les valeurs partagées du multistep afin que
    // la validation transverse (« au moins un article ») reste à jour depuis tout onglet.
    const articles = formContext.watch('articles') as StepArticle[] | undefined;
    React.useEffect(() => {
        updateFormValues({ articles });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [articles]);

    // Articles « réels » (hors lignes de mise en page LIB : sections / sauts de ligne).
    const hasRealArticle = (articles ?? []).some((article) => article.invoicingCategory !== 'LIB');

    return (
        <form noValidate>
            {isCreate && !hasRealArticle && (
                <Alert
                    severity="warning"
                    sx={{ marginBottom: '10px' }}
                >
                    Un package doit contenir au moins un article. Ajoutez-en un pour pouvoir
                    enregistrer.
                </Alert>
            )}
            <ArticlesModule
                formContext={formContext}
                isStepValidating={isStepValidating}
            />
        </form>
    );
};

export default ArticleStep;
